import styled from "styled-components";

const Divider = styled.div`
    border: 1px solid #EBEBEC;
`

export default Divider